/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTestDto } from './GetTestDto';
import {
    GetTestDtoFromJSON,
    GetTestDtoFromJSONTyped,
    GetTestDtoToJSON,
} from './GetTestDto';
import type { GetKeyTestDto } from './GetKeyTestDto';
import {
    GetKeyTestDtoFromJSON,
    GetKeyTestDtoFromJSONTyped,
    GetKeyTestDtoToJSON,
} from './GetKeyTestDto';

/**
 * 
 * @export
 * @interface GetIndicatorTestRecalculatedDto
 */
export interface GetIndicatorTestRecalculatedDto {
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestRecalculatedDto
     */
    id: string;
    /**
     * 
     * @type {GetTestDto}
     * @memberof GetIndicatorTestRecalculatedDto
     */
    test?: GetTestDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestRecalculatedDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestRecalculatedDto
     */
    mode?: GetIndicatorTestRecalculatedDtoModeEnum;
    /**
     * 
     * @type {GetKeyTestDto}
     * @memberof GetIndicatorTestRecalculatedDto
     */
    keyTest?: GetKeyTestDto | null;
    /**
     * 
     * @type {number}
     * @memberof GetIndicatorTestRecalculatedDto
     */
    result?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestRecalculatedDto
     */
    normName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetIndicatorTestRecalculatedDto
     */
    recalculatedResult?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestRecalculatedDto
     */
    interpretedResult?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestRecalculatedDto
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestRecalculatedDto
     */
    printText?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetIndicatorTestRecalculatedDto
     */
    isDefault?: boolean | null;
}


/**
 * @export
 */
export const GetIndicatorTestRecalculatedDtoModeEnum = {
    NumberOfCorrectAnswers: 'NumberOfCorrectAnswers',
    SumOfPresentationTime: 'SumOfPresentationTime',
    WeightedSum: 'WeightedSum',
    WeightedValueSum: 'WeightedValueSum'
} as const;
export type GetIndicatorTestRecalculatedDtoModeEnum = typeof GetIndicatorTestRecalculatedDtoModeEnum[keyof typeof GetIndicatorTestRecalculatedDtoModeEnum];


/**
 * Check if a given object implements the GetIndicatorTestRecalculatedDto interface.
 */
export function instanceOfGetIndicatorTestRecalculatedDto(value: object): value is GetIndicatorTestRecalculatedDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetIndicatorTestRecalculatedDtoFromJSON(json: any): GetIndicatorTestRecalculatedDto {
    return GetIndicatorTestRecalculatedDtoFromJSONTyped(json, false);
}

export function GetIndicatorTestRecalculatedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIndicatorTestRecalculatedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'test': json['test'] == null ? undefined : GetTestDtoFromJSON(json['test']),
        'name': json['name'] == null ? undefined : json['name'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'keyTest': json['keyTest'] == null ? undefined : GetKeyTestDtoFromJSON(json['keyTest']),
        'result': json['result'] == null ? undefined : json['result'],
        'normName': json['normName'] == null ? undefined : json['normName'],
        'recalculatedResult': json['recalculatedResult'] == null ? undefined : json['recalculatedResult'],
        'interpretedResult': json['interpretedResult'] == null ? undefined : json['interpretedResult'],
        'note': json['note'] == null ? undefined : json['note'],
        'printText': json['printText'] == null ? undefined : json['printText'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
    };
}

export function GetIndicatorTestRecalculatedDtoToJSON(value?: GetIndicatorTestRecalculatedDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'test': GetTestDtoToJSON(value['test']),
        'name': value['name'],
        'mode': value['mode'],
        'keyTest': GetKeyTestDtoToJSON(value['keyTest']),
        'result': value['result'],
        'normName': value['normName'],
        'recalculatedResult': value['recalculatedResult'],
        'interpretedResult': value['interpretedResult'],
        'note': value['note'],
        'printText': value['printText'],
        'isDefault': value['isDefault'],
    };
}

